import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    authBackground: true         if set true, <body> gets the branded auth background (login/full-screen pages)
  }
 */

// Extended route type to support hidden property at route level
type AppRouteRecordRaw = RouteRecordRaw & { hidden?: boolean };

const constantRoutes: AppRouteRecordRaw[] = [
  {
    path: "/link",
    component: Layout,
    hidden: true,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "noauth",
        component: () => import("@/views/redirect/index.vue"),
        meta: {
          requiresAuth: false,
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/acc",
    component: Layout,
    hidden: true,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: ":account_id",
        component: () => import("@/views/redirect/index.vue"),
        meta: {
          requiresAuth: false,
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    hidden: true,
    component: () => import("@/views/login/auth.vue"),
    meta: {
      requiresAuth: false,
      authBackground: true,
    },
    children: [
      {
        path: ":domain",
        name: "LoginDomain",
        component: () => import("@/views/login/auth.vue"),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/activate",
    name: "Activate",
    hidden: true,
    component: () => import("@/views/login/auth.vue"),
    meta: {
      requiresAuth: false,
      authBackground: true,
      title: "activate",
      noCache: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    hidden: true,
    component: () => import("@/views/login/auth.vue"),
    meta: {
      requiresAuth: false,
      authBackground: true,
      title: "activate",
      noCache: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    hidden: true,
    component: () => import("@/views/login/auth.vue"),
    meta: {
      requiresAuth: false,
      authBackground: true,
      title: "forgot password",
      noCache: true,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    hidden: true,
    component: () => import("@/views/login/auth.vue"),
    meta: {
      requiresAuth: false,
      authBackground: true,
      title: "reset password",
      noCache: true,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    hidden: true,
    meta: {
      // Full-screen spinner shown while logging out — branded background, no app content.
      requiresAuth: true,
      authBackground: true,
    },
    component: () => import("@/views/login/logout.vue"),
  },
  {
    path: "/404",
    name: "NotFound",
    hidden: true,
    component: () => import("@/views/error-page/404.vue"),
    meta: {},
  },
  {
    path: "/401",
    name: "Unauthorized",
    hidden: true,
    component: () => import("@/views/error-page/401.vue"),
    meta: {},
  },
  {
    path: "/",
    hidden: true,
    redirect: "/home",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/home",
    component: Layout,
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "home",
          icon: "home",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/accounts",
    name: "Accounts",
    hidden: true,
    component: () => import("@/views/accounts/index.vue"),
    meta: {
      // Full-screen account picker shown after login — keeps the branded auth background.
      requiresAuth: true,
      authBackground: true,
      noCache: true,
    },
  },
  {
    path: "/profile",
    component: Layout,
    hidden: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "Profile",
        component: () => import("@/views/profile/index.vue"),
        meta: {
          title: "profile",
          icon: "user",
          noCache: true,
        },
      },
    ],
  },
];

export default constantRoutes;
